export default __webpack_public_path__ + "static/media/Nosearch.f3b039b6.jpg";